import { createAsyncThunk } from '@reduxjs/toolkit';
import apiBilling from '@/lib/api/billing';
import { IUserSlice, TAddress } from '@/redux/slices/user/types';

export const postAddress = createAsyncThunk(
  'user/postAddress',
  apiBilling.postAddress
);

const fulfilled = (state: IUserSlice, { payload }: { payload: TAddress }) => {
  state.user.addresses.options = [...state.user.addresses.options, payload];
};

export default {
  action: postAddress,
  fulfilled,
};
